'use strict';

(function () {
  'use strict';

  angular.module('msSleep').component('msSleepTimePicker', {
    templateUrl: 'sleep/templates/sleep-time-picker.html',
    controller: SleepTimePicker,
    controllerAs: 'vm',
    bindings: {
      isDisabled: '<',
      defaultMeridiem: '<',
      /* <boolean> to indicate if dropdowns should be disabled */
      selectedTime: '<',
      /* time in Java format [h, m] */
      onChanged: '&'
      /* callback whenever dropdowns are updated */
    }
  });
  SleepTimePicker.$inject = ['$scope', '$log', '$rootScope'];

  /* This component takes a time in preferred Java format of [h,m] and visually renders it as 2 dropdowns */
  function SleepTimePicker($scope, $log, $rootScope) {
    var vm = this;
    vm.componentId = $scope.$id;
    vm.possibleHours = [].concat(_.range(1, 13, 1));

    //triggered when one-way bindings change
    vm.$onChanges = function () {
      if (isValidTime(vm.selectedTime)) {
        vm.parseSelectedTime();
      }
    };

    function isValidTime(time) {
      return _.isArray(time) && time.length === 2 && _.isNumber(time[0]) && _.isNumber(time[1]);
    }

    // Set dropdowns from time
    vm.parseSelectedTime = function () {
      vm.hour = vm.minute = '';

      var minutes = vm.selectedTime[1].toString();
      if (minutes === '0') {
        minutes = '00';
      }
      vm.minute = minutes;

      var hours = vm.selectedTime[0];
      if (hours > 12) {
        hours = hours - 12;
        vm.meridiem = 'pm';
      } else if (hours === 12) {
        vm.meridiem = 'pm';
      } else if (hours === 0) {
        hours = 12;
        vm.meridiem = 'am';
      } else {
        vm.meridiem = 'am';
      }
      vm.hour = hours.toString();
    };

    // Set time from dropdowns
    vm.setSelectedTime = function () {
      if (vm.defaultMeridiem && !vm.meridiem) {
        vm.meridiem = vm.defaultMeridiem;
      }
      var hour = parseInt(vm.hour);
      if (vm.meridiem === 'pm' && hour < 12) {
        hour = hour + 12;
      }
      if (vm.meridiem === 'am' && hour === 12) {
        hour = 0;
      }
      if (!vm.minute) {
        //default to 00 when hour is selected
        vm.minute = '00';
      }
      var minute = parseInt(vm.minute);
      if (_.isFunction(vm.onChanged)) {
        vm.onChanged({ time: [hour, minute] });
      }
    };

    vm.setOpenSelectState = function () {
      $rootScope.isSelectOpened = true;
    };

    vm.removeOpenSelectState = function () {
      delete $rootScope.isSelectOpened;
    };

    activate();

    ///////////////////////////////
    function activate() {
      $log.debug('SleepTimePicker activated');
    }
  }
})();